import React from "react";
import { Component } from "preact";
import classNames from "classnames";
import _ from "lodash";
import { Scrollbars } from "preact-custom-scrollbars";
import ImagePreview from "./widget/ImagePreview";


export default class Message extends Component {
    state = {
        open: false,
    };

    constructor() {
        super(...arguments);
        this.close = this.close.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.message !== nextProps.message || this.props.allowButton !== nextProps.allowButton || this.state.open !== nextState.open;
    }

    close(e) {
        if (e.data === "close") {
            if (this.state.open) {
                this.setState({ open: false });
            }
        }
    }

    componentDidMount() {
        window.addEventListener("message", this.close);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.close);
    }

    get buttons() {
        return this.props.allowButton && this.props.message.buttons;
    }

    handleRightScrollClick = () => {
        if (this.list) {
            let left = this.list.getScrollLeft();
            if (this.list.getScrollWidth() - this.list.getScrollLeft() <= (this.list.getClientWidth() * 2)) {
            }
            this.list.scrollLeft(left += this.props.cardWidth);
        }
    };


    handleLeftScrollClick = () => {
        if (this.list) {
            let left = this.list.getScrollLeft();
            if (this.list.getScrollLeft() <= this.props.cardWidth) {
            }
            this.list.scrollLeft(left -= this.props.cardWidth);
        }
    };

    getIconByFile(url) {
        return (<div className={"file-item"}>
            <i className={"icon-file-image-solid"} />
            <span className={"file-name"}>{
                _.truncate(url, {
                    length: 25,
                })
            }</span>
        </div>);
    }


    render() {
        const message = this.props.message;

        return (
            <div className={classNames("message-block", {
                income: message.getIsIncome(),
                outcome: message.getIsOutcome(),
            })}>
                {message.getIsIncome() && this.props.showImage &&
                    <div className="image-block">
                        <img className={"image"} src={this.props.image ? this.props.image : message.image} alt="" />
                    </div>
                }
                <div className="messages">
                    <div className="message-item">
                        <div className="message">
                            {typeof message.message === "function" ? (
                                <div style={{ display: "block" }}>{message.message()}</div>
                            ) : (<div style={{ display: "block" }}
                                      dangerouslySetInnerHTML={{ __html: message.message }} />)}
                            {
                                message.images && (
                                    <div className="message-img-wrapper">
                                        {
                                            message.images.map((img) => {
                                                return (
                                                    <ImagePreview
                                                        src={img.data.url}
                                                        key={img.id}
                                                    />

                                                );
                                            })
                                        }
                                    </div>
                                )
                            }
                            {
                                message.files && <div>
                                    {
                                        message.files.map((file, index) => {
                                            return (
                                                <div key={index}>
                                                    <a href={file.data.url} className="file" target="_blank">
                                                        {this.getIconByFile(file.data.url)}
                                                    </a>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            }
                            {
                                message.embed && <div>
                                    {
                                        message.embed.map((embed, i) => {
                                            return <iframe key={i} src={embed.data.url} frameborder="0" />;
                                        })
                                    }
                                </div>
                            }
                            {
                                message.videos && <div className="chat-message-video-wrapper">
                                    {
                                        message.videos.map((video, i) => {
                                            return (
                                                <video key={i} className="chat-message-video img-fluid" controls="controls">
                                                    <source src={video.data.url} />
                                                </video>
                                            );
                                        })
                                    }
                                </div>
                            }
                            {
                                message.audio && <div>
                                    {
                                        message.audio.map((audioItem, i) => {
                                            return (
                                                <audio
                                                    key={i}
                                                    className="chat-message-audio"
                                                    style={{ width: "100%", minWidth: 266 }}
                                                    controls
                                                    src={audioItem.data.url}
                                                />
                                            );
                                        })
                                    }
                                </div>
                            }
                            {
                                message.cards && (
                                        <div  className={"tc"}>
                                            {message.cards.elements.length > 1 &&
                                                <div className={"tc__right"} onClick={this.handleRightScrollClick}><i
                                                    className="icon-angle-right-solid" aria-hidden="true" /></div>}
                                            {message.cards.elements.length > 1 &&
                                                <div className={"tc__left"} onClick={this.handleLeftScrollClick}><i
                                                    className="icon-angle-left-solid" aria-hidden="true" /></div>}
                                            <Scrollbars
                                                ref={(el) => this.list = el}
                                                renderThumbHorizontal={props => <div {...props}
                                                                                     className="scroll-thumb-horizontal" />}
                                                renderTrackHorizontal={props => <div {...props}
                                                                                     className="scroll-track-horizontal" />}
                                                renderView={props => <div {...props} className="tc__cards" />}
                                            >
                                                {
                                                    message.cards.elements.map((card, cardIndex) => {
                                                        const buttons = card.buttons || [];
                                                        return <div key={cardIndex}
                                                                    className={classNames("tc__cards__card", {
                                                                        hasImg: card.image_url,
                                                                        small: message.cards.type === "invite",
                                                                    })}>
                                                            {card.image_url &&
                                                                <div className={"tc__cards__card__imgBlock"}><img
                                                                    className={"tc__cards__card__imgBlock__img"}
                                                                    src={card.image_url} alt={card.title} /></div>}
                                                            <div className={"tc__cards__card__textBlock"}>
                                                                <div className={"tc__cards__card__textBlock__title"}
                                                                     dangerouslySetInnerHTML={{ __html: card.title }}>{}</div>
                                                                <div className="tc__cards__card__textBlock__subtitle">
                                                                    <Scrollbars
                                                                        ref={(el) => this.list = el}
                                                                        renderThumbVertical={props => <div {...props}
                                                                                                           className="scroll-thumb-vertical" />}
                                                                        renderTrackVertical={props => <div {...props}
                                                                                                           className="scroll-track-vertical" />}
                                                                        renderView={props => <div {...props}
                                                                                                  className="scroll-view" />}
                                                                    >
                                                                        <div className="tc__cards__card__textBlock__subtitle__text"
                                                                            dangerouslySetInnerHTML={{ __html: card.subtitle }}>{}</div>
                                                                        {buttons.length ?
                                                                            <div className={"tc__cards__card__textBlock__btns"}>{
                                                                                buttons.map((button, buttonIndex) => {
                                                                                    switch (button.type) {
                                                                                        case "web_url":
                                                                                            return <a
                                                                                                key={buttonIndex}
                                                                                                className={"tc__cards__card__textBlock__btns__btn btn link_btn btn-secondary"}
                                                                                                target="_blank"
                                                                                                href={button.url}
                                                                                            >
                                                                                                {button.title}
                                                                                            </a>;
                                                                                        case "postback":
                                                                                            return <a
                                                                                                key={buttonIndex}
                                                                                                onClick={() => this.props.sendMessage(button.title, null, button.payload)}
                                                                                                className={"tc__cards__card__textBlock__btns__btn action_btn btn btn-secondary"}
                                                                                            >
                                                                                                {button.title}
                                                                                            </a>;
                                                                                    }
                                                                                })}
                                                                            </div>
                                                                            : ""
                                                                        }
                                                                    </Scrollbars>
                                                                </div>
                                                            </div>
                                                        </div>;
                                                    })
                                                }
                                            </Scrollbars>
                                        </div>
                                    )
                            }

                            {
                                this.buttons && <div>
                                    {
                                        this.buttons.map(({ text }, i) => <button key={i} className={"btn"}
                                                                                  onClick={() => this.props.sendMessage(text)}>{text}</button>)
                                    }
                                </div>
                            }
                            {
                                message.templateButtons && <div>
                                    {
                                        message.templateButtons.map(({ body, url, type }, i) => {
                                            if (type === "calendar") {
                                                return (
                                                    <div key={i}>
                                                        {this.state.open && <div className={"message-modal"}>
                                                            <iframe
                                                                src={url}
                                                                frameBorder={0}
                                                            />
                                                        </div>}
                                                        <a
                                                            className={"btn"}
                                                            onClick={() => {
                                                                this.setState({
                                                                    open: true,
                                                                });
                                                            }}
                                                        >
                                                            {body}
                                                        </a>
                                                    </div>
                                                );
                                            }

                                            return (<a key={i} className={"btn"} href={url}>{body}</a>);
                                        })
                                    }
                                </div>
                            }
                        </div>
                        <div className="time">
                            {this.props.time}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/Message.js